export default function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      text: 'Excellent service from start to finish. My car was picked up on time and delivered safely across the country. The driver was professional and kept me updated throughout the journey.',
      name: 'Sarah Mitchell',
      location: 'Los Angeles, CA',
      avatar: 'https://public.readdy.ai/ai/img_res/b7484e799981055d50fcb24a40b9a430.jpg'
    },
    {
      rating: 5,
      text: 'Best auto transport experience I have had. The quote was competitive, pickup was fast, and my vehicle arrived in perfect condition. Highly recommend their service to anyone shipping a car.',
      name: 'Michael Chen',
      location: 'Miami, FL',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20smiling%20headshot%20portrait%2C%20business%20casual%20attire%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20confident%20expression%2C%20high%20quality%20professional%20photography&width=80&height=80&seq=avatar-002&orientation=squarish'
    },
    {
      rating: 5,
      text: 'I was nervous about shipping my classic car, but they handled it with care. Enclosed transport option gave me peace of mind. The entire process was smooth and stress-free. Will use again.',
      name: 'Jennifer Rodriguez',
      location: 'Austin, TX',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20woman%20smiling%20headshot%20portrait%2C%20business%20casual%20attire%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20warm%20expression%2C%20high%20quality%20professional%20photography&width=80&height=80&seq=avatar-003&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">
          What Our Customers Say
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 text-base leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">
                    {testimonial.name}
                  </div>
                  <div className="text-gray-600 text-xs">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
